import {
    REALTIME_TRIPS_REQUEST,
    REALTIME_TRIPS_SUCCESS,
    REALTIME_TRIPS_FAIL,
    REALTIME_TRIPS_RESET,

    REALTIME_SPEED_REQUEST,
    REALTIME_SPEED_SUCCESS,
    REALTIME_SPEED_FAIL,
    REALTIME_SPEED_RESET,

} from '../constants/realtimeConstants'


import { axiosAuthed, getAuthedToken } from "../auth/createAuthedAxios.ts";

let speedAbortController = null;
let speedRequestSeq = 0;

async function postSpeedWithQueryToken(url, body, signal) {
    const makeRequest = async (forceRefresh = false) => {
        const token = await getAuthedToken(forceRefresh, true);
        const requestUrl = new URL(url, window.location.href);
        if (token) {
            requestUrl.searchParams.set("access_token", token);
        }

        const response = await fetch(requestUrl.toString(), {
            method: "POST",
            headers: {
                "accept": "application/json",
                "Content-Type": "text/plain",
            },
            body: JSON.stringify(body),
            signal,
        });

        return response;
    };

    let response = await makeRequest(false);
    if (response.status === 401) {
        response = await makeRequest(true);
    }

    if (!response.ok) {
        let detail = response.statusText;
        try {
            const errorBody = await response.json();
            detail = errorBody.detail ?? detail;
        } catch (_) {
            detail = await response.text();
        }
        throw new Error(detail || `Request failed with status ${response.status}`);
    }

    return response.json();
}

export const getRealTimeTrips = () => async (dispatch) => {


   
    try {
        dispatch({
            type: REALTIME_TRIPS_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}trips2/current/timestamp`

        const { data } = await axiosAuthed.get(

            url,
            config
        )


        dispatch({
            type: REALTIME_TRIPS_SUCCESS,
            payload: data
        })



    } catch (error) {
        dispatch({
            type: REALTIME_TRIPS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}



export const getRealTimeSpeed = (idxs) => async (dispatch) => {
    if (!Array.isArray(idxs) || idxs.length === 0) {
        return;
    }

    speedAbortController?.abort();
    const requestSeq = speedRequestSeq + 1;
    speedRequestSeq = requestSeq;
    const controller = new AbortController();
    speedAbortController = controller;
    const timeoutId = setTimeout(() => controller.abort(), 15 * 1000);

    try {
        dispatch({
            type: REALTIME_SPEED_REQUEST
        })

        

        let timestamp = new Date().getTime()/1000
        timestamp = timestamp-timestamp%30
    
        const strigifiedIdxs = JSON.stringify(idxs)
        const todo = {"title":strigifiedIdxs}
        
        const url = `${process.env.REACT_APP_HOST_IP}network/speed/${timestamp}`

        const data = await postSpeedWithQueryToken(url, todo, controller.signal)

        if (requestSeq !== speedRequestSeq) {
            return;
        }


        dispatch({
            type: REALTIME_SPEED_SUCCESS,
            payload: data
        })



    } catch (error) {
        if (controller.signal.aborted || error.name === "AbortError") {
            return;
        }
        if (requestSeq !== speedRequestSeq) {
            return;
        }
        dispatch({
            type: REALTIME_SPEED_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    } finally {
        clearTimeout(timeoutId);
        if (speedAbortController === controller) {
            speedAbortController = null;
        }
    }
}
